
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.625 8.5h-.592l-.21-.203A4.853 4.853 0 0010 5.125 4.875 4.875 0 105.125 10a4.853 4.853 0 003.172-1.178l.203.21v.593l3.75 3.742 1.117-1.117L9.625 8.5zm-4.5 0A3.37 3.37 0 011.75 5.125 3.37 3.37 0 015.125 1.75 3.37 3.37 0 018.5 5.125 3.37 3.37 0 015.125 8.5z","fill":"currentColor"}})])
          )
        }
      }
    